import { jsx as _jsx } from "react/jsx-runtime";
var HoneyPot = function (props) {
    return (_jsx("div", { style: { display: "none" }, children: _jsx("input", { type: "text", name: props.name, id: props.name, defaultValue: "" }) }));
};
export default HoneyPot;
